import i18n from '@/utils/i18n'
import keyMirror from 'keymirror'

export const actionTexts = () => {
  return {
    DISAPPROVE: i18n.t('tenantProjects.submission.comment.disapprove'),
    PROCEED_NO_FOLLOW_UP: i18n.t('tenantProjects.submission.comment.proceedWithNoFollowUp'),
    PROCEED_CP_FOLLOW_UP: i18n.t('tenantProjects.submission.comment.proceedWithCPFollowUp'),
  }
}

export const emailActionTexts = () => {
  return {
    DISAPPROVE: i18n.t('tenantProjects.submission.comment.disapproved'),
    PROCEED_NO_FOLLOW_UP: i18n.t('tenantProjects.submission.comment.proceedWithNoFollowUp'),
    PROCEED_CP_FOLLOW_UP: i18n.t('tenantProjects.submission.comment.proceedWithCPFollowUp'),
  }
}

export const CommentTypes = keyMirror({
  DESIGN: null,
  TECH: null,
})

export const CommentActionTypes = keyMirror({
  DELETE: null,
  REVIEW: null,
  UPDATE: null,
  CHECK: null,
  UNCHECK: null,
  ADD: null,
  SEND: null,
  RESEND: null,
})

export const CommentObject = keyMirror({
  SUBMISSION: null,
  COMMENT: null,
})
